import React from 'react';
import { Route } from 'react-router-dom';
import MainLayout from '../layouts/MainLayout';
import MainDashboard from '../pages/MainDashboard';
import CompanyLogin from '../pages/CompanyLogin';
import BranchLogin from '../pages/BranchLogin';
import CompanyLayout from '../layouts/CompanyLayout';
import CompanyDashboard from '../pages/CompanyDashboard';
import BranchLayout from '../layouts/BranchLayout';
import BranchDashboard from '../pages/BranchDashboard';

const branchRoutes = {
  path: '/branch-dashboard',
  element: <BranchLayout/>,
  children: [
    {
      index: true,
      element: <BranchDashboard />
    },
    // {
    //   path: 'branch-login',
    //   element: <BranchLogin />
    // },
    
  ]
}; 

export default branchRoutes;
